import { useCallback, useMemo } from 'react'
import { provider } from 'web3-core'

// utils
import { getContract } from '../../utils/bakery/erc20'
import {
  approve
} from '../../sushi/utils'
import { userExchangeNFTContract } from '../../userType/userExchangeNFTContract'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '../'
import { userTokenAddress } from '../../userType/userTokenAddress'

const useApproveERC20 = (type?: string, tokenName?: string) => {
  const { account, library } = useActiveWeb3React()
  const ethereum = library?.provider
  const sushi = useYam()
  let lpTokenAddress = userTokenAddress(sushi, tokenName)
  const lpContract = useMemo(() => {
    return getContract(ethereum as provider, lpTokenAddress)
  }, [ethereum, lpTokenAddress])

  let contract = userExchangeNFTContract(sushi, type)

  const handleApprove = useCallback(async () => {
    try {
      const tx = await approve(lpContract, contract, account)
      return tx
    } catch (e) {
      console.log('useApproveERC20-->>', e)
      return false
    }
  }, [account, lpContract, contract])

  return handleApprove
}

export default useApproveERC20
